export type ClassNameValue = string | false | null | undefined;

export function joinClassNames(...values: ClassNameValue[]) {
  return values.filter((value): value is string => typeof value === "string" && value.length > 0).join(" ");
}
